export default "<div>\r\n    <canvas width=\"600\" height=\"480\" #canvas class=\"canvas\"></canvas>\r\n</div>"